import { name } from "./block.json";

/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @param object block The block html element.
 *
 * @return  void
 */
export function initializeBlock(block) {
  console.log("init block");
  const travelsList = document.querySelector('.travel-floating-info');
  document.addEventListener('click', event => {
    if (!event.target.id) return;
    if (event.target.id == 'travels-list-toggle') {
      event.preventDefault();
      document.body.classList.toggle('travels-visible');
      if ( document.body.classList.contains('travels-visible') ) {
        travelsList?.scrollIntoView();
      }
    }
  });

}
